import React from 'react';
import styled from 'styled-components';
import WarningIcon from '../ui/icon/WarningIcon';

const WarningMessageContainer = styled.div`
  color: var(--color-medium-gray);
  padding: 10px 10px 0 10px;
  font-size: var(--font-size-400);
`;

const WarningMessage = styled.span`
  margin-left: 8px;
`;

const UnsharableFlagsWarning: React.FC = () => {
  return (
    <WarningMessageContainer>
      <WarningIcon />
      <WarningMessage>
        Some of the selected flags are system flags and cannot be shared.
      </WarningMessage>
    </WarningMessageContainer>
  );
};

export default UnsharableFlagsWarning;
